<script setup lang="ts">
import {FraudReportNotification} from "@/core/interfaces/fraud/fraud";
import ExtensionLogo from "@/extension/components/extension-logo/ExtensionLogo.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";

const props = defineProps<{
    report: FraudReportNotification | undefined;
}>();

const show = () => {
    window.ipcRenderer.send(
        'navigate',
        `/asafo/${props.report!.customers[0].id}`,
        false
    );
};
</script>

<template>
  <div v-if="report?.customers?.length" class="flex ml-5 rounded-lg bg-white shadow-custom" @click="show">
    <div class="relative pl-9 flex flex-col justify-center text-sm">
      <div class="flex flex-col flex-1 text-wrap p-4 gap-2">
        <div>
          Patient signalé sur la liste des fausses ordonnances
        </div>
        <div class="flex">
          <BaseButton density="compact" class="w-48 text-wrap overflow-ellipsis line-clamp-1">
            <span class="text-xs">Voir les signalements</span>
          </BaseButton>
        </div>
      </div>
      <div class="absolute -left-[25px] w-[50px] h-[50px]">
        <ExtensionLogo v-if="report.extension" :extension="report.extension" class="rounded-lg w-full h-full" />
      </div>
    </div>
  </div>
</template>
